type UsageOdometerRpcClient = {
  rpc: (
    fn: string,
    args?: Record<string, unknown>
  ) => PromiseLike<{ error?: { message?: string } | null }> | { error?: { message?: string } | null }
}

export type UsageOdometerDeltaInput = {
  syncPushCountDelta?: number
  syncPullCountDelta?: number
  syncPushBytesDelta?: number
  syncPullBytesDelta?: number
  realtimeEventCountDelta?: number
}

export type UsageOdometerRpcArgs = {
  sync_push_count_delta: number
  sync_pull_count_delta: number
  sync_push_bytes_delta: number
  sync_pull_bytes_delta: number
  realtime_event_count_delta: number
}

const USAGE_ODOMETER_RPC = 'increment_usage_odometer_monthly'

export function clampUsageOdometerDelta(value: number | null | undefined): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 0
  if (!Number.isInteger(value)) return Math.max(0, Math.round(value))
  return Math.max(0, value)
}

export function toUsageOdometerRpcArgs(input: UsageOdometerDeltaInput): UsageOdometerRpcArgs {
  return {
    sync_push_count_delta: clampUsageOdometerDelta(input.syncPushCountDelta),
    sync_pull_count_delta: clampUsageOdometerDelta(input.syncPullCountDelta),
    sync_push_bytes_delta: clampUsageOdometerDelta(input.syncPushBytesDelta),
    sync_pull_bytes_delta: clampUsageOdometerDelta(input.syncPullBytesDelta),
    realtime_event_count_delta: clampUsageOdometerDelta(input.realtimeEventCountDelta)
  }
}

export function hasUsageOdometerDelta(args: UsageOdometerRpcArgs): boolean {
  return Object.values(args).some((value) => value > 0)
}

export function measureUtf8Bytes(value: string): number {
  return new TextEncoder().encode(value).length
}

export async function incrementUsageOdometer(
  input: UsageOdometerDeltaInput,
  client: UsageOdometerRpcClient | undefined
): Promise<boolean> {
  if (!client) return false
  const args = toUsageOdometerRpcArgs(input)
  if (!hasUsageOdometerDelta(args)) return true
  const { error } = await client.rpc(USAGE_ODOMETER_RPC, args)
  return !error
}
